import React, { createContext, useContext } from 'react';
import { useCurrency } from './useCurrency';
interface CurrencyContextType {
  formatPrice: (usdAmount: number) => string;
  formatPriceShort: (usdAmount: number) => string;
  currencyCode: string;
  loading: boolean;
}
const CurrencyContext = createContext<CurrencyContextType>({
  formatPrice: n => `$${n.toFixed(2)} USD`,
  formatPriceShort: n => `$${n.toFixed(2)}`,
  currencyCode: 'USD',
  loading: false
});
export function CurrencyProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const {
    currency,
    formatPrice,
    formatPriceShort,
    loading
  } = useCurrency();
  return <CurrencyContext.Provider value={{
    formatPrice,
    formatPriceShort,
    currencyCode: currency.code,
    loading
  }} data-id="element-359">
      {children}
    </CurrencyContext.Provider>;
}
export function useCurrencyContext() {
  return useContext(CurrencyContext);
}